import {
    Button,
    MenuItem,
    Modal,
    TextField,
} from "@mui/material";
import { React, useState } from 'react'
export const ModalAgregarDocumentoSC = ({ open, onClose, documentosMhusa, documentosJDF, onGuardar }) => {

    const [documento, setDocumento] = useState({
        iddocumentoJDF: 0,
        iddocumentoMhusa: 0
    });

    const onCerrar = () => {
        onClose()
    }

    const onAgregar = () => {
        onGuardar([documento])

        setDocumento({
            iddocumentoJDF: 0,
            iddocumentoMhusa: 0
        })

        onClose()
    }
    return (
        <Modal open={open}>
            <div className="modal-agregar-documento-sc-main-container">
                <div className="credito-agregar-modal-title">

                    <div className="modal-agregar-powergard-main-titulo">
                        <h3>AGREGAR RELACION </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            className="cell"
                            size="small"
                            label="Documentos JDF"
                            variant="outlined"
                            select
                            value={documento.iddocumentoJDF}
                            onChange={(e) => setDocumento({ ...documento, iddocumentoJDF: e.target.value })}
                        >
                            {documentosJDF.map((opt) => (
                                <MenuItem key={opt.iddocumento} value={opt.iddocumento}>
                                    {opt.documento}
                                </MenuItem>
                            ))}
                        </TextField>

                        {/* COLUMNA FLECHAS */}
                        <div className="columna-flechas">
                            <div className="flecha-header"></div>
                            <div className="flecha-fila">
                                →
                            </div>
                        </div>

                        <TextField
                            className="cell"
                            size="small"
                            label="Documentos Mhusa"
                            variant="outlined"
                            select
                            value={documento.iddocumentoMhusa}
                            onChange={(e) => setDocumento({ ...documento, iddocumentoMhusa: e.target.value })}
                        >
                            {documentosMhusa.map((opt) => (
                                <MenuItem key={opt.iddocumento} value={opt.iddocumento}>
                                    {opt.documento}
                                </MenuItem>
                            ))}
                        </TextField>

                    </div>

                </div>

                <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={onCerrar} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onAgregar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

